import groupBy from 'lodash/groupBy';
import store from '@/store';

export function transformPartnerList(data) {
  const partners = data.hits.map(result => result._source);
  if (store.getters.UserHasRole('Provider') || store.getters.UserHasRole('Partner')) {
    return partners;
  }
  const grouped = groupBy(partners, 'parent_id');

  if (!grouped[null]) return [];

  return grouped[null].map(partner => {
    partner.children = grouped[partner.id] || [];
    return partner;
  });
}

export function transformProductList(data) {
  return data.hits.map(result => result._source);
}
